export const normalizeEmail = (email?: string | null) =>
  email?.trim().toLowerCase() ?? "";

export const hasTeacherEmail = (
  client: Pick<Client, "teachers">,
  email?: string | null,
) => {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) return false;

  return Boolean(
    client.teachers?.some(
      (teacher) => normalizeEmail(teacher.email) === normalizedEmail,
    ),
  );
};

export const findClientForTeacher = (
  clients: Client[],
  email?: string | null,
) => clients.find((client) => hasTeacherEmail(client, email)) ?? null;

export const findTeacherForClient = (
  client: Pick<Client, "teachers">,
  email?: string | null,
) => {
  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) return null;

  return (
    client.teachers?.find(
      (teacher) => normalizeEmail(teacher.email) === normalizedEmail,
    ) ?? null
  );
};

export const findClientForAdmin = (
  clients: Client[],
  uid?: string | null,
  email?: string | null,
) => {
  const clientByAuthId = uid
    ? clients.find((client) => client.authId === uid)
    : null;

  if (clientByAuthId) return clientByAuthId;

  const normalizedEmail = normalizeEmail(email);
  if (!normalizedEmail) return null;

  return (
    clients.find(
      (client) => normalizeEmail(client.adminEmail) === normalizedEmail,
    ) ?? null
  );
};
